import { Form, Input, Select, Row, Col, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import { useEffect } from "react";

export default function ClassificationFieldsForm({
  onFinish,
  initialValues,
  form,
  productCateogory,

  instrumentType,
  assetClass,
  countryOfIssuer,
  issuerType,
}) {
  console.log(productCateogory);
  useEffect(() => {
    if (initialValues && Object.keys(initialValues).length > 0) {
      form.setFieldsValue(initialValues);
    }
  }, [initialValues, form]);
  return (
    <div>
      <h3 style={{ marginBottom: "24px", fontWeight: "600" }}>
        Classification Fields
      </h3>

      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        initialValues={initialValues}
      >
        {/* Classification Fields Section */}
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Product Category
                  <Tooltip title="High-level classification that groups securities by behavioural product family.">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="instrumentCategoryId"
              rules={[
                { required: true, message: "Please select product code" },
              ]}
            >
              <Select
                placeholder="Select product code"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
              >
                {productCateogory.map((product) => (
                  <Select.Option key={product.value} value={product.value}>
                    {product.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Instrument Type
                  <Tooltip title="Specific type of financial instrument represented by the security.(Treasury Bill, Fixed Rate Bond, Float Rate Note (FRN), Commercial Paper.)">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="instrumentTypeId"
              rules={[
                { required: true, message: "Please select instrument type" },
              ]}
            >
              <Select
                placeholder="Select instrument type"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
              >
                {instrumentType.map((instrument) => (
                  <Select.Option
                    key={instrument.value}
                    value={instrument.value}
                  >
                    {instrument.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Asset Class
                  <Tooltip title="Broad asset class to which the security belongs( Money Market, Fixed Income, Equity)">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="assetClassId"
              rules={[{ required: true, message: "Please select asset class" }]}
            >
              <Select
                placeholder="Select asset class"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
              >
                {assetClass.map((asset) => (
                  <Select.Option key={asset.value} value={asset.value}>
                    {asset.label}
                  </Select.Option>
                ))}
                <Select.Option value="fixed-income">Fixed Income</Select.Option>
                <Select.Option value="equity">Equity</Select.Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Issuer Type
                  <Tooltip title="Classification of the entity issuing the security.( Sovereign, Corporate, Bank, Supranational.)">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="issueTypeId"
              rules={[{ required: true, message: "Please select issuer type" }]}
            >
              <Select
                placeholder="Select issuer type"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
              >
                {issuerType.map((issuerType) => (
                  <Select.Option
                    key={issuerType.value}
                    value={issuerType.value}
                  >
                    {issuerType.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Issuer Name
                  <Tooltip title="Legal name of the entity that issued the security.">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="issueName"
              rules={[{ required: true, message: "Please enter issuer name" }]}
            >
              <Input
                className="bond-input"
                style={{ height: 44 }}
                placeholder="e.g., CBN, FGN, Standard Bank, MTN"
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Country of Issuer
                  <Tooltip title="Country in which the issuing entity is domiciled">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="countryId"
              rules={[{ required: true, message: "Please select country" }]}
            >
              <Select
                showSearch
                placeholder="Country of Issuer"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option?.children
                    ?.toString()
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                {countryOfIssuer.map((country) => (
                  <Select.Option key={country.value} value={country.value}>
                    {country.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row style={{ marginTop: "12px" }}>
          <Col span={24}>
            <div
              style={{
                backgroundColor: "#f5f5f5",
                padding: "12px",
                borderRadius: "4px",
                fontSize: "12px",
                color: "#666",
              }}
            >
              <strong>Note:</strong> These fields drive exposure, risk
              weighting, reporting, and regulatory classification.
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
}
